import React, { Component } from 'react';
import './test.css';
import { Form, Card, Button, Popup } from 'semantic-ui-react'
import axios from 'axios'

class signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first: '',
      last: '',
      email: '',
      referral: '',
      emailError: false,
      referralError: false,
      firstError: false,
      lastError: false  
    }

    this.submitRegister = this.submitRegister.bind(this)
  }

  componentWillMount() {
    //console.log("MOUNTING")
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  async submitRegister() {
    var { firstError, lastError, emailError, referralError } = this.state;

    //Basic Error checks to ensure form is filled out
    this.state.first.length < 1 ? firstError = true : firstError = false ;
    this.state.last.length < 1 ? lastError = true : lastError = false;
    this.state.email.indexOf("@") < 0 ? emailError = true : emailError = false;

    if (!firstError && !lastError && !emailError) {
      var refCodeGood = true
     /* await axios.get('/api/checkRefCode', {
        params: {
          refCode: this.state.referral
        }
      })
      .then(function(res, err) {
        if (res.data) { 
          refCodeGood = true
          referralError = false;
        }
      })*/

      if (refCodeGood) {
        await axios.get('/api/signUpUser', {
          params: {
            signUp: { 
              FirstName: this.state.first,
              LastName: this.state.last,
              email_addr: this.state.email,
              active_ind: 1 
            }, refCode: this.state.referral
          }
        })
        .then(function(res, err) {
          if (res.data === false) {
            alert("Email address already exists. Please use another email address.")
          } else {
            if (!res.data[0]) {
              var d = new Date();
              d.setTime(d.getTime() + (24*60*60*10));
              var expires = "expires="+ d.toUTCString();
              document.cookie = "loggedIn=true;" + expires
              document.cookie = "loggedInUser=" + res.data[1] + ";" + expires
              document.cookie = "loggedInId=" + res.data[2] + ";" + expires
              document.location.href = "/test"
            } else { alert("Sign up failed. Please try again later.") }
          }
        })
      } else { referralError = true; }
    } else { this.setState({emailError: emailError, firstError: firstError, lastError: lastError}) }
    this.setState({referralError: referralError})
  }

  render() {
    const { first, last, email, referral, emailError, firstError, lastError, referralError } = this.state

    return (
      <div>
        <Card style={{margin: 'auto'}}>
          <Card.Content>
          <h2>Welcome!</h2>
            <Card.Header>
              Register
            </Card.Header>
            <Card.Description>
              <Form onSubmit={this.submitRegister}>
                <Form.Input error={firstError} label='First Name' style={{marginBottom: '5px'}} name='first' value={first} onChange={this.handleChange} />
                <Form.Input error={lastError} label='Last Name' style={{marginBottom: '5px'}} name='last' value={last} onChange={this.handleChange} />
                <Popup
                  trigger={<Form.Input error={emailError} label='Email Address' style={{marginBottom: '5px'}} name='email' value={email} onChange={this.handleChange} />}
                  content='Email Address must contain @'
                  open={emailError}
                  position='right center'
                />
                {/*<Form.Input error={referralError} label='Referral Link' style={{marginBottom: '5px'}} name='referral' value={referral} onChange={this.handleChange} />*/}
                <Button className="logRegisterButton" primary fluid type='submit'>Register</Button>
              </Form>
            </Card.Description>
          </Card.Content>
        </Card>
        
      </div>
    );
  }
}

export default signup;



// WEBPACK FOOTER //
// ./src/pages/signup.js